import Vue from "vue";
import VueI18n from "vue-i18n";

import pt_BR from "./locales/pt_BR";

Vue.use(VueI18n);

const messages = {
  pt_BR
};

const i18n = new VueI18n({
  locale: navigator.language.replace("-", "_"),
  fallbackLocale: {
    default: ["pt_BR"]
  },
  messages
});

export default i18n;
